import { fetchAsObservable } from 'fetcher!sofe';
import { pluck } from 'rxjs/operators';

export const getTasksByEngagementId = engagementId => {
  return fetchAsObservable(`/api/engagements/${engagementId}/tasks`).pipe(
    pluck('task')
  );
};

export const addFilesToTask = (taskId, files) => {
  return fetchAsObservable(`/api/tasks/${taskId}/files`, {
    method: 'POST',
    body: {
      related_files: {
        file_ids: files
      }
    }
  });
};

export const getDocsToUpload = (clientId, engagementId, versionId) => {
  return fetchAsObservable(
    `/wg/clients/${clientId}/engagements/${engagementId}/versions/${versionId}/reports/1040Organizer`
  ).pipe(pluck('reports', 'values'));
};

export const getSurveyDownloadTitle = engagementId => {
  return fetchAsObservable(
    `/api/tasks?engagement_id=${engagementId}&service_type=tax_return`
  ).pipe(pluck('tasks'));
};
